import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { EstadoVazio } from '@/componentes/ui/estados';
import { Botao } from '@/componentes/ui/botao';

export function NaoEncontrado(): JSX.Element {
  return (
    <div className="grid h-full place-items-center p-6">
      <EstadoVazio
        titulo="Página não encontrada"
        detalhe="O endereço acessado não existe no WMS."
        icone={<Compass className="h-7 w-7" />}
        acao={
          <Botao comoFilho variante="primaria">
            <Link to="/">Voltar ao início</Link>
          </Botao>
        }
      />
    </div>
  );
}
